// MAP SYSTEM: colour multiplier for UNLIT painted materials (foliage cards and cores), so they follow the time of day like
// the lit world does. White by day (no change); render/timeOfDay.ts sets it from the preset's `paint` colour.
import * as THREE from 'three/webgpu';
import { uniform } from 'three/tsl';
export const PAINT_TINT = uniform(new THREE.Color(1, 1, 1));
